import { useMap } from 'react-leaflet';

import { Avatar } from '../../../Atomics/Avatar';
import Box from '../../../Atomics/Box';
import CustomIcon from '../../../Icons/CustomIcon';

import { useTranslationContext } from '../../../../../contexts/TranslationContext';
import { StyledButton } from '../../../Atomics/Button';

export const MyLocationControl = () => {
    const { resources } = useTranslationContext();
    const map = useMap();

    const handleFlyToPosition = () => {
        map.locate().on('locationfound', (e: any) => {
            map.flyTo(e.latlng, map.getZoom());
        });
    };

    return (
        <Box>
            <StyledButton onClick={() => handleFlyToPosition()} title={resources.label.showYourLocation}>
                <Avatar bg="black-1" size={32}>
                    <CustomIcon icon="Localization_sm" customColor="white" />
                </Avatar>
            </StyledButton>
        </Box>
    );
};
